import React from 'react';
import {
  BannerCarousel,
  BannerCarouselProps,
} from '@vfuk/core-banner-carousel';
import {
  StandardBanner,
  StandardBannerProps,
} from '@vfuk/core-standard-banner';
import { SectionBannerCarouselProps } from './types/SectionBannerCarousel.types';
import { fireButtonClickEventWithSeoEventData } from '../../../../helpers/SeoHelpers';
import fireButtonAndLinkClicksEvent from '../../../../helpers/fireButtonAndLinkClicksEvent';
import { StandardBannerWrapper } from './styles/SectionElementStandardBanner.styles';
import { BannerCarouselWrapper } from './styles/SectionBannerCarousel.styles';
import { CtaButtonProps } from '../../Elements/CtaButtons/types/CtaButtonRow.types';

const SectionBannerCarousel = ({
  waitTime,
  banners,
}: SectionBannerCarouselProps) => {
  if (!banners) {
    return null;
  }

  const standardBanners: BannerCarouselProps['banners'] = banners.map(
    banner => {
      const createBannerButton: (
        button: CtaButtonProps | null
      ) => StandardBannerProps[
        | 'primaryButton'
        | 'secondaryButton'] = button => {
        if (!button) {
          return;
        }

        return {
          text: button.label,
          href: button.url,
          onClick: () =>
            fireButtonClickEventWithSeoEventData({
              label: button.label,
              seoEventData: button.seoEventData,
            }),
        };
      };

      return {
        title: banner.bannerCarouselTitle || banner.headingText,
        child: (
          <StandardBannerWrapper backgroundColor={banner.backgroundColor}>
            <StandardBanner
              appearance="primary"
              backgroundColor={banner.backgroundColor}
              heading={{ text: banner.headingText, level: banner.headingLevel }}
              contentAlignment={banner.contentAlignment}
              paragraph={{ text: banner.paragraph }}
              contentSize={banner.contentSize}
              primaryButton={createBannerButton(banner.primaryButton)}
              secondaryButton={createBannerButton(banner.secondaryButton)}
              backgroundImage={{
                sm: {
                  src:
                    banner.backgroundImage.gatsbyImageData.images.fallback
                      ?.src || '',
                },
              }}
              footnote={{
                text: banner.footnoteText,
                link: banner.footnoteLinkText
                  ? {
                      text: banner.footnoteLinkText,
                      href: banner.footnoteLinkUrl,
                      onClick: () =>
                        fireButtonAndLinkClicksEvent({
                          event_label: banner.footnoteLinkText || '',
                          event_action: 'link click',
                        }),
                    }
                  : undefined,
              }}
            />
          </StandardBannerWrapper>
        ),
      };
    }
  );

  return (
    <BannerCarouselWrapper>
      <BannerCarousel
        srName="Banner Carousel"
        showNavigation
        waitTime={waitTime}
        banners={standardBanners}
      />
    </BannerCarouselWrapper>
  );
};

export default SectionBannerCarousel;
